














import { defineComponent, PropType } from '@vue/composition-api';
import formItemRejectReason from '@/components/common/form-item-reject-reason/index.vue';
import questionTooltip from '@/components/common/question-tooltip/index.vue';
import { RejectReason } from './../../../common/form-item-reject-reason/types';

const name = 'ttam-creative-website-url-reject-reason';
export default defineComponent({
  name,
  components: {
    questionTooltip,
    formItemRejectReason,
  },
  props: {
    showLabel: {
      type: Boolean,
      default: false,
    },
    rejectReason: {
      type: Array as PropType<RejectReason[]>,
      default: () => [],
    },
  },
  setup() {
    const rejectNames = ['material_external_url', 'material_utm'];

    return {
      name,
      rejectNames,
    };
  },
});
